import StaffList from './StaffList.vue';

export default {
    StaffList,
};



// WEBPACK FOOTER //
// ./src/components/Management/index.js